import Vue from 'vue'
export default new Vue()

//import EventBus from './message.event.bus';

//controller side
//mounted: function () {
//    EventBus.$on('SubScreenDoneButtonPushed', () => {
//        this.mode = 'Entry';
//    });
//},
//destroyed: function () {
//    EventBus.$off('SubScreenDoneButtonPushed');
//},

//Caller side:

//emit SubScreenDoneButtonPushed 

//EventBus.$emit('goToTemplate', 'templateIdToSelect');

//calls:
//('goToTemplate', 'templateId') - to set the message screen to a specific template
//('SubScreenDoneButtonPushed') - when the sub screen (when you into appointment request mobile view - it takes over the screen)
//('ClearError', 'propertyNameToClear') - component will call directory to the root to clear any errors for the given property
//('IsUploading', 'isuploading (true / false') - upload component will directly call the bus to say if we are uploading or not
